import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

export const COLUMNS_DATA = ({
  deleteRow,
  editRow,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Doctor Name",
    accessor: "doctor_obj.doctor_name",
  },
  {
    Header: "Clinic Name",
    accessor: "clinic_obj.clinic_name",
  },
  {
    Header: "Clinic Address",
    accessor: "clinic_obj.clinic_address",
  },
  {
    Header: "Zone",
    accessor: "zone_obj.zone_name",
  },
  {
    Header: "Days",
    accessor: "day_of_week",
    Cell: ({ value }) => value?.join(", "),
  },
  {
    Header: "Start Time",
    accessor: "start_time",
  },
  {
    Header: "End Time",
    accessor: "end_time",
  },
  {
    Header: "Slot Duration (min)",
    accessor: "slot_duration",
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
  },
  {
    Header: "",
    accessor: "id",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
          >
            More...
          </button>

          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editRow(cell.row.original)}
              >
                Edit
              </button>
            </li>

            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];

export const DOCTOR_SCHEDULE_ROUTER_FORM_CONFIG = (rowData) => [
  {
    label: "Doctor",
    type: "select",
    name: "refer_doctor_name",
    defaultValue: rowData?.doctor_id || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Clinic",
    type: "select",
    name: "clinic_id",
    defaultValue: rowData?.clinic_id || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Clinic Name",
    type: "input-text",
    name: "clinic_name",
    defaultValue: rowData?.clinic_name || "",
    validations: {
      required: true,
      maxLength: 255,
    },
  },
  {
    label: "Day of Week",
    type: "input-select-multiple",
    name: "day_of_week",
    defaultValue: rowData?.day_of_week || [],
    validations: {
      required: true,
    },
    options: [
      { label: "Sunday", value: 0 },
      { label: "Monday", value: 1 },
      { label: "Tuesday", value: 2 },
      { label: "Wednesday", value: 3 },
      { label: "Thursday", value: 4 },
      { label: "Friday", value: 5 },
      { label: "Saturday", value: 6 },
    ],
  },
  {
    label: "Start Time",
    type: "input-time",
    name: "start_time",
    defaultValue: rowData?.start_time || "",
    validations: {
      required: true,
    },
  },
  {
    label: "End Time",
    type: "input-time",
    name: "end_time",
    defaultValue: rowData?.end_time || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Slot Duration (mins)",
    type: "input-number",
    name: "slot_duration",
    defaultValue: rowData?.slot_duration || "",
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [
  { key: "clinic_name", value: "Clinic Name" },
  { key: "clinic_address", value: "Clinic Address" },
];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
